export const taskApiURl = {
  getList: "/task",
  addTask: "/task/add",
  updateTask: "/task/update",
  acceptanceStatus: "/task/acceptance-status",
  updateTaskTo: "/task/assign",
  updateCompletionStatus: "/task/completion-status",
  bulkUpdateCompletionStatus: "/task/bulk-completion-status",
  taskLogs: "/task/task-log",
};
